import {
  anAction,
  anInsight,
  anInsightStatusName,
  aSignal,
  aTeamPage,
  aUser,
  aUserPage,
  InsightDetailInsightFragment,
  mockInsightQueryOperationQuery,
} from '__generated__';

import {
  CUSTOM_INSIGHT_RESOLUTION,
  PARENT_NAME,
} from './InsightResolutionQueryOperation.mocks';
import {
  CLOSED_STATUS_DISPLAY_NAME,
  CLOSED_STATUS_NAME,
  NEW_STATUS_DISPLAY_NAME,
  NEW_STATUS_NAME,
} from './InsightStatusesOperation.mocks';

const baseInsightOverrides = {
  signals: [aSignal()],
  assignee: {
    ...aUser(), // assignee is not guaranteed to have username associated with it, this forces it to be a user with a username
  },
  status: {
    ...anInsightStatusName({
      name: NEW_STATUS_NAME,
      displayName: NEW_STATUS_DISPLAY_NAME,
    }),
  },
  // The mocked response has gotten too large for the Cypress tests to parse. This was causing the insight.spec to fail with new schema additions.
  // Setting a bunch of stuff that isn't being tested explicitly to reduce the payload size.
  enrichments: [],
  relatedEnrichments: [],
  comments: [],
  involvedEntities: [],
  relatedIncidents: [],
  relatedInsights: [],
};

export const insightQuery_closed = mockInsightQueryOperationQuery(
  (_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        actions: [anAction()],
        insight: anInsight({
          ...baseInsightOverrides,
          resolution: PARENT_NAME,
          subResolution: CUSTOM_INSIGHT_RESOLUTION.name,
          status: {
            ...anInsightStatusName({
              name: CLOSED_STATUS_NAME,
              displayName: CLOSED_STATUS_DISPLAY_NAME,
            }),
          },
        }) as InsightDetailInsightFragment,
        teams: aTeamPage(),
        users: aUserPage(),
      })
    );
  }
);

export const getInsightQuery_tagsUpdated = (updatedTags: string[]) =>
  mockInsightQueryOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        actions: [anAction()],
        insight: anInsight({
          tags: updatedTags,
          ...baseInsightOverrides,
        }) as InsightDetailInsightFragment,
        teams: aTeamPage(),
        users: aUserPage(),
      })
    );
  });

export const handlers = [
  mockInsightQueryOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        actions: [anAction()],
        insight: anInsight({
          resolution: null,
          subResolution: null,
          ...baseInsightOverrides,
        }) as InsightDetailInsightFragment,
        teams: aTeamPage(),
        users: aUserPage(),
      })
    );
  }),
];
